import { render, staticRenderFns } from "./PhysicalAssessment.vue?vue&type=template&id=1fe4e8bb&"
import script from "./PhysicalAssessment.vue?vue&type=script&lang=ts&"
export * from "./PhysicalAssessment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fe4e8bb')) {
      api.createRecord('1fe4e8bb', component.options)
    } else {
      api.reload('1fe4e8bb', component.options)
    }
    module.hot.accept("./PhysicalAssessment.vue?vue&type=template&id=1fe4e8bb&", function () {
      api.rerender('1fe4e8bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/Application/Sections/PhysicalAssessment.vue"
export default component.exports